import { render, staticRenderFns } from "./notificacion_iva.vue?vue&type=template&id=2c513b17"
import script from "./notificacion_iva.js?vue&type=script&lang=js&external"
export * from "./notificacion_iva.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports